// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2NNQA","buttons":"SendReceipts_buttons__3AVzi","email":"SendReceipts_email__2sIa1","bookApptTitle":"SendReceipts_bookApptTitle__1je47"};